<script setup>
import { ref, onMounted } from 'vue'
import { fetchMenus } from '@/api/menu'
import { fetchFeaAdditionalSettings } from '@/api/common' // 假设这是你的接口方法

// 页脚平台二维码（客户提供，按效果图顺序展示）
import qrWechatMp from '@/assets/images/qr/wechat-mp.jpg'
import qrDouyin from '@/assets/images/qr/douyin.jpg'
import qrWechatChannels from '@/assets/images/qr/wechat-channels.jpg'
import qrXiaohongshu from '@/assets/images/qr/xiaohongshu.jpg'
import qrZhihu from '@/assets/images/qr/zhihu.jpg'
import qrBilibili from '@/assets/images/qr/bilibili.jpg'

const qrList = [
  { label: '公众号', src: qrWechatMp },
  { label: '抖音', src: qrDouyin },
  { label: '视频号', src: qrWechatChannels },
  { label: '小红书', src: qrXiaohongshu },
  { label: '知乎', src: qrZhihu },
  { label: 'B站', src: qrBilibili },
]

const footerItems = ref([])
const loading = ref(true)
const currentYear = new Date().getFullYear()

const companyData = ref({
  company_phone: '400-123-4567',
  company_email: 'contact@company.com',
  company_address: '北京市海淀区科技园路88号'
})

onMounted(async () => {
  try {
    const data = await fetchMenus()
    const excludedPaths = ['/', '/login', '/register']
    footerItems.value = (data.menuItems || []).filter(item => {
      const href = item.status?.href?.trim().replace(/\/$/, '') || ''
      return !excludedPaths.includes(href)
    })
    console.log(footerItems, "footeritems")
  } catch (error) {
    console.error('加载菜单失败:', error)
  } finally {
    loading.value = false
  }

  try {
    const response = await fetchFeaAdditionalSettings()
    companyData.value = {
      company_phone: response.company_phone || '400-123-4567',
      company_email: response.company_email || 'contact@company.com',
      company_address: response.company_address || '北京市海淀区科技园路88号'
    }
  } catch (error) {
    console.error('加载公司数据失败:', error)
  }
})
</script>

<template>
  <footer class="app-footer">
    <!-- 菜单部分 -->
    <div class="footer-menu">
      <div class="container">
        <nav v-if="!loading" class="menu-grid">
          <template v-for="item in footerItems" :key="item.metadata.name">
            <div class="menu-column" v-if="item.status.href != '/'">
              <router-link :to="item.status.href" class="menu-item primary">
                {{ item.status.displayName }}
              </router-link>
              <div v-if="item.children && item.children.length" class="submenu-items">
                <router-link v-for="child in item.children" :key="child.metadata.name" :to="child.status.href"
                  class="menu-item secondary">
                  {{ child.status.displayName }}
                </router-link>
              </div>
            </div>
          </template>

          <div class="menu-column">
            <div class="menu-item primary">寻求合作，联系我们</div>
            <div class="submenu-items">
              <!-- 电话按客户要求固定为 13501251657；后台 company_phone 仍是旧的 400 号，且该插件无后台设置界面 -->
              <span class="menu-item secondary contact-text">电话：13501251657</span>
              <span class="menu-item secondary contact-text">邮箱：{{ companyData.company_email }}</span>
              <span class="menu-item secondary contact-text">地址：{{ companyData.company_address }}</span>
            </div>
          </div>


        </nav>
        <div v-else class="loading">
          加载菜单中...
        </div>
      </div>
    </div>

    <!-- 更多了解方式：平台二维码（按效果图展示） -->
    <div class="footer-contact">
      <div class="container">
        <div class="contact-content">
          <p class="contact-title">更多了解方式链接</p>
          <div class="qr-list">
            <div v-for="qr in qrList" :key="qr.label" class="qr-item">
              <img :src="qr.src" :alt="qr.label" class="qr-image">
              <span class="qr-label">{{ qr.label }}</span>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- 版权信息 + ICP 备案号 -->
    <div class="footer-copyright">
      <div class="container">
        <p class="copyright-line">
          <span>© {{ currentYear }} 得一致远（北京）工业技术有限公司</span>
          <a href="https://beian.miit.gov.cn/" target="_blank" rel="noopener">京ICP备2023039983号-1</a>
        </p>
      </div>
    </div>
  </footer>
</template>

 <style scoped>
/* 原样保留你的样式 */
.app-footer {
  background-color: #004989;
  color: #fff;
}

.container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 20px;
}

.footer-menu {
  padding: 30px 0;
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);
}

.menu-grid {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  gap: 24px 32px;
}

.menu-column {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.menu-item {
  color: #fff;
  text-decoration: none;
  transition: opacity 0.3s;
  white-space: nowrap;
}

.menu-item.primary {
  font-size: 16px;
  font-weight: 500;
  margin-bottom: 5px;
}

.menu-item.secondary {
  font-size: 14px;
  color: rgba(255, 255, 255, 0.9);
  /* padding-left: 15px; */
}

.menu-item:hover {
  opacity: 0.8;
  text-decoration: underline;
}

.submenu-items {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.footer-contact {
  padding: 40px 0;
}

.contact-content {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.contact-info {
  display: flex;
  align-items: center;
  gap: 30px;
}

.contact-title {
  font-size: 16px;
  font-weight: 500;
  margin: 0;
}

.contact-methods {
  display: flex;
  gap: 20px;
}

.contact-text {
  font-size: 14px;
  color: rgba(255, 255, 255, 0.9);
}

.qr-list {
  display: flex;
  gap: 20px;
  flex-wrap: wrap;
}

.qr-item {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
}

.qr-image {
  width: 88px;
  height: 88px;
  background: #fff;
  border-radius: 4px;
  padding: 4px;
  object-fit: contain;
}

.qr-label {
  font-size: 13px;
  color: rgba(255, 255, 255, 0.9);
}

.footer-bottom {
  padding: 20px 0;
  border-top: 1px solid rgba(255, 255, 255, 0.1);
}

.footer-bottom .container {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.disclaimer p {
  font-size: 12px;
  color: rgba(255, 255, 255, 0.6);
  margin: 0;
}

.footer-legal {
  display: flex;
  gap: 20px;
}

.footer-legal a {
  color: rgba(255, 255, 255, 0.9);
  text-decoration: none;
  font-size: 14px;
}

.footer-legal a:hover {
  text-decoration: underline;
}

.footer-copyright {
  background-color: rgba(0, 0, 0, 0.2);
  padding: 15px 0;
  text-align: center;
}

.footer-copyright p {
  margin: 0;
  font-size: 14px;
  color: rgba(255, 255, 255, 0.9);
}

.footer-copyright .copyright-line {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  align-items: center;
  gap: 6px 20px;
}

.footer-copyright a {
  color: rgba(255, 255, 255, 0.9);
  text-decoration: none;
}

.footer-copyright a:hover {
  text-decoration: underline;
}

.loading {
  color: rgba(255, 255, 255, 0.9);
  text-align: center;
  padding: 20px;
}

@media (max-width: 768px) {
  .menu-grid {
    grid-template-columns: repeat(auto-fill, minmax(150px, 1fr));
    gap: 20px;
  }

  .contact-content {
    flex-direction: column;
    gap: 20px;
    align-items: flex-start;
  }

  .contact-info {
    flex-direction: column;
    gap: 10px;
    align-items: flex-start;
  }

  .contact-methods {
    flex-direction: column;
    gap: 10px;
  }

  .footer-bottom .container {
    flex-direction: column;
    gap: 10px;
    text-align: center;
  }

  .footer-legal {
    justify-content: center;
  }

  .qr-list {
    margin-top: 20px;
    gap: 16px;
    justify-content: flex-start;
  }
}
</style> 
